import { z } from 'zod';
import { isMobilePhone } from 'validator';

export const updateProfileSchema = z.object({
  id: z.string().optional(),
  firstName: z.string().min(2, 'First name should have at least 2 characters'),
  lastName: z.string().min(2, 'Last name should have at least 2 characters'),
  city: z.string().min(1, 'City is required'),
  mobile: z.string().refine(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    (value) => isMobilePhone(value, 'en-AU'),
    'Mobile number is required'
  ),
  company: z.string().min(2, 'Company is required'),
  position: z.string().min(2, 'Position is required'),
  industry: z.string().min(2, 'Industry is required'),
  website: z.string().optional(),
  twitter: z.string().optional(),
  instagram: z.string().optional(),
  interests: z.array(z.string()).optional()
});

export type UpdateProfileDetails = z.infer<typeof updateProfileSchema>;
